import actionTypes from '../actionTypes';

const initialState = {
  zoomSDK: false
};

const FeatureFlagsReducer = (state = initialState, action) => {
  if (action.type === actionTypes.SET_ZOOM_SDK_FLAG) {
    return {
      ...state,
      zoomSDK: action.payload
    };
  }
  return state;
};

export default FeatureFlagsReducer;
